import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme, alpha, LinearProgress } from "@mui/material";
import { motion } from "framer-motion";

const SplashScreen = ({ onComplete }) => {
    const theme = useTheme();
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) { clearInterval(interval); return 100; }
                return prev + 4;
            });
        }, 60);

        const timeout = setTimeout(onComplete, 2000);
        return () => { clearInterval(interval); clearTimeout(timeout); };
    }, [onComplete]);

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: theme.palette.gradient.bg,
                zIndex: 9999,
            }}
        >
            {/* Sparkle particles */}
            {[...Array(12)].map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        position: "absolute",
                        width: { xs: 3, sm: 4 },
                        height: { xs: 3, sm: 4 },
                        borderRadius: "50%",
                        backgroundColor: alpha(theme.palette.primary.main, 0.4),
                        top: `${10 + Math.random() * 80}%`,
                        left: `${5 + Math.random() * 90}%`,
                        animation: `float ${2 + Math.random() * 3}s ease-in-out ${Math.random() * 2}s infinite`,
                    }}
                />
            ))}

            <motion.div
                initial={{ opacity: 0, scale: 0.6, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <Box
                    component="img"
                    src="/assets/logo/rmcs-logo.png"
                    alt="RMCS"
                    sx={{ width: 80, height: 80, borderRadius: 3, mb: 2 }}
                />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.5 }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 900,
                        letterSpacing: 3,
                        background: theme.palette.gradient.brand,
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        mb: 0.5,
                    }}
                >
                    RMCS
                </Typography>
            </motion.div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.6 }}
                transition={{ delay: 0.5, duration: 0.5 }}
            >
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 4, letterSpacing: 1 }}>
                    Raja · Mantri · Chor · Sipahi
                </Typography>
            </motion.div>

            {/* Loading bar */}
            <motion.div
                initial={{ opacity: 0, width: 0 }}
                animate={{ opacity: 1, width: 200 }}
                transition={{ delay: 0.6, duration: 0.4 }}
            >
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        width: 200,
                        height: 3,
                        borderRadius: 2,
                        backgroundColor: alpha(theme.palette.primary.main, 0.15),
                        "& .MuiLinearProgress-bar": {
                            borderRadius: 2,
                            background: theme.palette.gradient.brand,
                        },
                    }}
                />
            </motion.div>
        </Box>
    );
};

export default SplashScreen;
